import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonToolbar } from 'reactstrap';
import { Field, FieldArray } from 'redux-form';
import ArrowUpBold from 'mdi-react/ArrowUpBoldIcon';
import ArrowDownBoldIcon from 'mdi-react/ArrowDownBoldIcon';
import TrashCanOutlineIcon from 'mdi-react/TrashCanOutlineIcon';
import hiddenField from '../../../shared/components/form/HiddenField';
import renderField from '../../../shared/components/form/TextField';
import RenderPackagesFlows from './RenderPackagesFlows';
import getObjectId from './getObjectId';

const marginTop20 = { marginTop: '20px' };

class RenderPackages extends PureComponent {
  static moveToUp(fields, index) {
    if (index > 0) {
      fields.swap(index, index - 1);
    }
  }

  static moveToDown(fields, index) {
    if (fields.length - 1 !== index) {
      fields.swap(index, index + 1);
    }
  }

  static async addPackage(fields) {
    const objectId = await getObjectId();
    fields.push({ id: objectId });
  }

  static propTypes = {
    fields: PropTypes.objectOf(PropTypes.any).isRequired,
    meta: PropTypes.objectOf(PropTypes.any).isRequired,
    options: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.any)).isRequired,
  };

  render() {
    const {
      fields,
      meta: { error, submitFailed },
      options,
    } = this.props;
    const { moveToUp, moveToDown, addPackage } = RenderPackages;
    const { instantFlows } = options;

    return (
      <div className="form__form-group">
        <ButtonToolbar className="form__button-toolbar wizard__toolbar">
          <Button color="primary" size="sm" onClick={() => addPackage(fields)}>
            Добавить пакет
          </Button>
        </ButtonToolbar>
        {submitFailed && error && (
          <div className="form__form-group">
            <div>
              <span className="form__form-group-error">{error}</span>
            </div>
          </div>
        )}
        {fields.map((pack, index) => (
          <div key={index} className="form__form-group">
            <span className="form__form-group-label">Пакет # {index + 1}</span>
            <div className="form__form-group-field">
              <Field name={`${pack}.name`} component={renderField} type="text" placeholder="Название пакета" />
              <Field name={`${pack}.id`} component={hiddenField} />
              <div className="form__form-group-icon">
                <ArrowUpBold onClick={() => moveToUp(fields, index)} />
              </div>
              <div className="form__form-group-icon">
                <ArrowDownBoldIcon onClick={() => moveToDown(fields, index)} />
              </div>
              <div className="form__form-group-icon">
                <TrashCanOutlineIcon onClick={() => fields.remove(index)} />
              </div>
            </div>
            <div className="form__form-group-field" style={marginTop20}>
              <Field name={`${pack}.amoId`} component={renderField} type="number" placeholder="AMO ID" />
            </div>
            <div className="form__form-group-field">
              <FieldArray
                name={`${pack}.bonuses`}
                component={RenderPackagesFlows}
                props={{ options: { instantFlows } }}
              />
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default RenderPackages;
